import { AccessProvider } from '../../../contexts/accessProvider.tsx';
import { RecipesContextProvider } from '../../../contexts/recipes/recipes.tsx';
import { Role } from '../../../models/enums/role.ts';
import RecipesBody from './body.tsx';
import RecipesHeader from './header.tsx';

const AdminRecipes = () => {
    return (
        <AccessProvider roles={[Role.admin, Role.superAdmin]}>
            <RecipesContextProvider>
                <RecipesHeader />
                <RecipesBody />
            </RecipesContextProvider>
        </AccessProvider>
    );
};

export default AdminRecipes;
